module.exports = __webpack_public_path__ + "media/images/swifticons/profile-e40108c7bc57a1ef1c76a50d067bde31.svg";